import React, { useState } from "react";
import "../Services/Services.css";

const Services = () => {
  const [showOverlay, setShowOverlay] = useState(false);

  const handleOverlay = () => {
    setShowOverlay(!showOverlay);
  };

  return (
    <>
      <div className="full-ser">
        <h1 className="ser-head">OUR Services</h1>
        <p className="ser-p">We provide the perfect service for you.</p>
        <div className="services">
          <div className="ser-l">
            <div className="service-item">
              <img src="l11.webp" alt="Logo 1" className="service-logo" />
              <div>
                <h5>Expert Plant Care Services</h5>
                <p>
                  Ensuring your plants thrive with professional maintenance
                  services.
                </p>
              </div>
            </div>
            <div className="service-item">
              <img src="l2.webp" alt="Logo 2" className="service-logo" />
              <div>
                <h5>Premium Pressure Washing Solutions</h5>
                <p>
                  Rejuvenating outdoor spaces with effective cleaning solutions.
                </p>
              </div>
            </div>
            <div className="service-item">
              <img src="l3.webp" alt="Logo 3" className="service-logo" />
              <div>
                <h5>Professional Tree Services & Trimming</h5>
                <p>Professional trimming to maintain tree health and beauty.</p>
              </div>
            </div>
          </div>

          <div className="ser-r">
            <div className="video-wrapper" onClick={handleOverlay}>
              <video src="services.mp4" muted className="service-video"></video>
              <div className="play-button">▶</div>
            </div>
          </div>

          {showOverlay && (
            <div className="overlay-s">
              <div className="overlay-content-s">
                <button className="close-btn-s" onClick={handleOverlay}>
                  ✖
                </button>
                <video
                  src="video.mp4"
                  controls
                  autoPlay
                  className="overlay-video"
                ></video>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Services;
